export default "<md-select class=\"u-m-none gw-fade-in ng-animated\" placeholder=\"Passport Type\" ng-if=$ctrl.passportProducts ng-model=$ctrl.passportType ng-change=$ctrl.goToProduct()> <md-option ng-repeat=\"product in $ctrl.passportProducts\" ng-value=product.subtype> {{ ::product.label }} </md-option> </md-select> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/passport-select/passport-select.html
// module id = MFHA
// module chunks = 1